/**
 * Lightweight native toast notification helper.
 * Replaces the deprecated noty package.
 */

const CONTAINER_ID = 'xanta-toast-container';
const DEFAULT_TIMEOUT = 3000;

const themes = {
    success: { background: '#d4edda', color: '#155724', border: '#c3e6cb' },
    error: { background: '#f8d7da', color: '#721c24', border: '#f5c6cb' },
    warning: { background: '#fff3cd', color: '#856404', border: '#ffeeba' },
    info: { background: '#d1ecf1', color: '#0c5460', border: '#bee5eb' },
    alert: { background: '#e2e3e5', color: '#383d41', border: '#d6d8db' }
};

function getContainer() {
    let container = document.getElementById(CONTAINER_ID);
    if (!container) {
        container = document.createElement('div');
        container.id = CONTAINER_ID;
        container.style.cssText = `
            position: fixed;
            top: 16px;
            right: 16px;
            z-index: 9999;
            display: flex;
            flex-direction: column;
            gap: 8px;
            max-width: 320px;
            pointer-events: none;
        `;
        document.body.appendChild(container);
    }
    return container;
}

export function show(text, type = 'info', timeout = DEFAULT_TIMEOUT) {
    const theme = themes[type] || themes.info;
    const toast = document.createElement('div');
    toast.style.cssText = `
        padding: 12px 16px;
        border-radius: 4px;
        border: 1px solid ${theme.border};
        background: ${theme.background};
        color: ${theme.color};
        font-family: inherit;
        font-size: 0.95rem;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        opacity: 0;
        transform: translateX(100%);
        transition: opacity 250ms ease, transform 250ms ease;
        pointer-events: auto;
    `;
    toast.textContent = text;

    getContainer().appendChild(toast);

    requestAnimationFrame(() => {
        toast.style.opacity = '1';
        toast.style.transform = 'translateX(0)';
    });

    const remove = () => {
        toast.style.opacity = '0';
        toast.style.transform = 'translateX(100%)';
        setTimeout(() => {
            if (toast.parentNode) toast.parentNode.removeChild(toast);
        }, 250);
    };

    if (timeout > 0) {
        setTimeout(remove, timeout);
    }

    toast.addEventListener('click', remove);
}

export default { show };
